import { 
  BusinessOpportunity, 
  BusinessProposal,
  ProposalItem,
  ProposalSignature,
  BusinessContract,
  ContractSignatory,
  ProposalStatus,
  OpportunityStatus
} from '@/types/business-opportunities';
import { v4 as uuidv4 } from 'uuid';

// Customer data
export const mockCustomers = [
  {
    id: 'cust_001',
    name: 'Empresa ABC Ltda.',
    legal_name: 'ABC Soluções Empresariais Ltda.',
    business_identification_number: '12.345.678/0001-90',
    address: 'Av. Paulista, 1000',
    city: 'São Paulo',
    state: 'SP',
    zip: '01310-100',
    logo_url: 'https://via.placeholder.com/150?text=ABC',
  },
  {
    id: 'cust_002',
    name: 'Tech Solutions S.A.',
    legal_name: 'Tech Solutions Tecnologia S.A.',
    business_identification_number: '98.765.432/0001-10',
    address: 'Rua da Inovação, 500',
    city: 'Belo Horizonte',
    state: 'MG',
    zip: '30130-170',
    logo_url: 'https://via.placeholder.com/150?text=Tech',
  },
  {
    id: 'cust_003',
    name: 'Educandário Carandá',
    legal_name: 'Instituto Educacional Carandá Ltda.',
    business_identification_number: '45.876.543/0001-21',
    address: 'Rua dos Educadores, 123',
    city: 'Rio de Janeiro',
    state: 'RJ',
    zip: '22220-000',
    logo_url: 'https://via.placeholder.com/150?text=Caranda',
  }
];

// Business Opportunities
export const mockOpportunities: BusinessOpportunity[] = [
  {
    id: 'op_001',
    organization_id: 'org_default',
    customer_id: 'cust_001',
    name: 'Implementação ERP',
    description: 'Implementação de sistema ERP para gerenciamento de recursos empresariais',
    total_value: 85000,
    currency_code: 'BRL',
    status: 'open',
    probability: 80,
    expected_close_date: '2023-12-30',
    created_at: '2023-10-15T10:00:00Z',
    updated_at: '2023-10-15T10:00:00Z',
  },
  {
    id: 'op_002',
    organization_id: 'org_default',
    customer_id: 'cust_002',
    name: 'Consultoria Estratégica',
    description: 'Serviços de consultoria para planejamento estratégico e transformação digital',
    total_value: 125000,
    currency_code: 'BRL',
    status: 'open',
    probability: 90,
    expected_close_date: '2023-11-30',
    created_at: '2023-10-10T14:30:00Z',
    updated_at: '2023-10-10T14:30:00Z',
  },
  {
    id: 'op_003',
    organization_id: 'org_default',
    customer_id: 'cust_003',
    name: 'Sistema de Gestão Educacional',
    description: 'Implementação de sistema de gestão educacional completo para automatização de processos administrativos e pedagógicos',
    total_value: 150000,
    currency_code: 'BRL',
    status: 'open',
    probability: 75,
    expected_close_date: '2024-01-15',
    created_at: '2023-10-20T09:45:00Z',
    updated_at: '2023-10-20T09:45:00Z',
  }
];

// Business Proposals
export const mockProposals: BusinessProposal[] = [
  {
    id: 'prop_001',
    opportunity_id: 'op_001',
    version: 1,
    title: 'Proposta Comercial - Implementação ERP',
    description: 'Proposta para implementação completa de sistema ERP, incluindo parametrização, migração de dados e treinamento',
    total_value: 85000,
    currency_code: 'BRL',
    template_type: 'services',
    status: 'sent',
    valid_until: '2023-12-30',
    pdf_url: 'https://www.africau.edu/images/default/sample.pdf',
    public_token: 'token-abc-123',
    created_at: '2023-10-18T15:30:00Z',
    updated_at: '2023-10-20T10:15:00Z',
  },
  {
    id: 'prop_002',
    opportunity_id: 'op_002',
    version: 1,
    title: 'Proposta de Consultoria Estratégica',
    description: 'Serviços de consultoria para transformação digital e otimização de processos',
    total_value: 125000,
    currency_code: 'BRL',
    template_type: 'consultancy',
    status: 'draft',
    valid_until: '2023-11-30',
    public_token: 'token-def-456',
    created_at: '2023-10-12T11:45:00Z',
    updated_at: '2023-10-12T11:45:00Z',
  },
  {
    id: 'prop_003',
    opportunity_id: 'op_003',
    version: 1,
    title: 'Proposta_Carandá_Educação',
    description: 'Sistema integrado de gestão educacional para automatização de processos e aumento de eficiência operacional',
    total_value: 150000,
    currency_code: 'BRL',
    template_type: 'licensing',
    status: 'viewed',
    valid_until: '2024-01-31',
    pdf_url: 'https://www.africau.edu/images/default/sample.pdf',
    public_token: 'token-ghi-789',
    created_at: '2023-10-22T14:00:00Z',
    updated_at: '2023-10-25T09:30:00Z',
  }
];

// Proposal Items
export const mockProposalItems: ProposalItem[] = [
  // Items for Proposal 1
  {
    id: 'item_001',
    proposal_id: 'prop_001',
    description: 'Licença ERP Básica',
    quantity: 1,
    unit_price: 35000,
    unit_measure: 'unidade',
    discount_percentage: 0,
    total_price: 35000,
    created_at: '2023-10-18T15:30:00Z',
    updated_at: '2023-10-18T15:30:00Z',
  },
  {
    id: 'item_002',
    proposal_id: 'prop_001',
    description: 'Serviço de Implementação',
    quantity: 200,
    unit_price: 200,
    unit_measure: 'hora',
    discount_percentage: 5,
    total_price: 38000,
    created_at: '2023-10-18T15:30:00Z',
    updated_at: '2023-10-18T15:30:00Z',
  },
  {
    id: 'item_003',
    proposal_id: 'prop_001',
    description: 'Treinamento da Equipe',
    quantity: 40,
    unit_price: 300,
    unit_measure: 'hora',
    discount_percentage: 0,
    total_price: 12000,
    created_at: '2023-10-18T15:30:00Z',
    updated_at: '2023-10-18T15:30:00Z',
  },
  
  // Items for Proposal 2
  {
    id: 'item_004',
    proposal_id: 'prop_002',
    description: 'Diagnóstico de Processos',
    quantity: 1,
    unit_price: 45000,
    unit_measure: 'projeto',
    discount_percentage: 0,
    total_price: 45000,
    created_at: '2023-10-12T11:45:00Z',
    updated_at: '2023-10-12T11:45:00Z',
  },
  {
    id: 'item_005',
    proposal_id: 'prop_002',
    description: 'Consultoria de Implementação',
    quantity: 300,
    unit_price: 250,
    unit_measure: 'hora',
    discount_percentage: 10,
    total_price: 67500,
    created_at: '2023-10-12T11:45:00Z',
    updated_at: '2023-10-12T11:45:00Z',
  },
  {
    id: 'item_006',
    proposal_id: 'prop_002',
    description: 'Workshop de Inovação',
    quantity: 5,
    unit_price: 2500,
    unit_measure: 'sessão',
    discount_percentage: 0,
    total_price: 12500,
    created_at: '2023-10-12T11:45:00Z',
    updated_at: '2023-10-12T11:45:00Z',
  },
  
  // Items for Proposal 3
  {
    id: 'item_007',
    proposal_id: 'prop_003',
    description: 'Licença Software Gestão Escolar',
    quantity: 1,
    unit_price: 80000,
    unit_measure: 'licença',
    discount_percentage: 5,
    total_price: 76000,
    created_at: '2023-10-22T14:00:00Z',
    updated_at: '2023-10-22T14:00:00Z',
  },
  {
    id: 'item_008',
    proposal_id: 'prop_003',
    description: 'Implementação e Customização',
    quantity: 250,
    unit_price: 220,
    unit_measure: 'hora',
    discount_percentage: 0,
    total_price: 55000,
    created_at: '2023-10-22T14:00:00Z',
    updated_at: '2023-10-22T14:00:00Z',
  },
  {
    id: 'item_009',
    proposal_id: 'prop_003',
    description: 'Treinamento de Professores e Staff',
    quantity: 60,
    unit_price: 325,
    unit_measure: 'hora',
    discount_percentage: 10,
    total_price: 19000,
    created_at: '2023-10-22T14:00:00Z',
    updated_at: '2023-10-22T14:00:00Z',
  }
];

// Proposal Signatures
export const mockProposalSignatures: ProposalSignature[] = [
  {
    id: 'sig_001',
    proposal_id: 'prop_001',
    signer_name: 'Carlos Silva',
    signer_email: 'carlos.silva@empresaabc.com.br',
    signer_title: 'Diretor Financeiro',
    signer_company: 'ABC Soluções Empresariais Ltda.',
    signed_at: '2023-10-25T16:45:00Z',
    signature_ip: '187.45.123.67',
    signature_image_url: 'https://via.placeholder.com/200x100?text=Signature',
    created_at: '2023-10-25T16:45:00Z',
    updated_at: '2023-10-25T16:45:00Z',
  }
];

// Business Contracts
export const mockContracts: BusinessContract[] = [
  {
    id: 'contract_001',
    proposal_id: 'prop_001',
    customer_id: 'cust_001',
    title: 'Contrato de Prestação de Serviços - Implementação ERP',
    description: 'Contrato formal para implementação do sistema ERP conforme proposta aprovada',
    template_type: 'services',
    status: 'active',
    start_date: '2023-11-01',
    end_date: '2024-05-01',
    total_value: 85000,
    currency_code: 'BRL',
    pdf_url: 'https://www.africau.edu/images/default/sample.pdf',
    created_at: '2023-10-27T10:30:00Z',
    updated_at: '2023-10-27T10:30:00Z',
  }
];

// Contract Signatories
export const mockContractSignatories: ContractSignatory[] = [
  {
    id: 'sig_contract_001',
    contract_id: 'contract_001',
    name: 'Carlos Silva',
    email: 'carlos.silva@empresaabc.com.br',
    title: 'Diretor Financeiro',
    company: 'ABC Soluções Empresariais Ltda.',
    role: 'contractee',
    signed_at: '2023-10-27T10:15:00Z',
    created_at: '2023-10-27T09:30:00Z',
    updated_at: '2023-10-27T10:15:00Z',
  },
  {
    id: 'sig_contract_002',
    contract_id: 'contract_001',
    name: 'Maria Oliveira',
    email: 'maria.oliveira@suaempresa.com.br',
    title: 'Diretora Comercial',
    company: 'Sua Empresa S.A.',
    role: 'contractor',
    signed_at: '2023-10-27T09:45:00Z',
    created_at: '2023-10-27T09:30:00Z',
    updated_at: '2023-10-27T09:45:00Z',
  }
];

export const generateMockToken = (): string => {
  return `mocktoken-${uuidv4().substring(0, 8)}`;
};

export const generateMockProposalWithItems = (opportunityId: string, customerId: string): { proposal: BusinessProposal, items: ProposalItem[] } => {
  const now = new Date();
  const validUntil = new Date();
  validUntil.setMonth(validUntil.getMonth() + 1);
  
  const proposalId = `prop_${uuidv4().substring(0, 8)}`;
  const publicToken = generateMockToken();
  
  const proposal: BusinessProposal = {
    id: proposalId,
    opportunity_id: opportunityId,
    version: 1,
    title: 'Nova Proposta Comercial',
    description: 'Proposta de serviços personalizados para atender às necessidades do cliente',
    total_value: 0, // Will be calculated from items
    currency_code: 'BRL',
    template_type: 'services',
    status: 'draft',
    valid_until: validUntil.toISOString(),
    public_token: publicToken,
    created_at: now.toISOString(),
    updated_at: now.toISOString(),
  };

  // Generate 2-4 random items
  const numItems = Math.floor(Math.random() * 3) + 2;
  const items: ProposalItem[] = [];
  
  let totalValue = 0;
  
  for (let i = 0; i < numItems; i++) {
    const quantity = Math.floor(Math.random() * 10) + 1;
    const unitPrice = Math.floor(Math.random() * 5000) + 1000;
    const discount = Math.floor(Math.random() * 20);
    const totalPrice = quantity * unitPrice * (1 - discount / 100);
    
    totalValue += totalPrice;
    
    items.push({
      id: `item_${uuidv4().substring(0, 8)}`,
      proposal_id: proposalId,
      description: `Item de Proposta ${i + 1}`,
      quantity,
      unit_price: unitPrice,
      unit_measure: i % 2 === 0 ? 'unidade' : 'hora',
      discount_percentage: discount,
      total_price: totalPrice,
      created_at: now.toISOString(),
      updated_at: now.toISOString(),
    });
  }
  
  // Update proposal total value
  proposal.total_value = totalValue;
  
  return { proposal, items };
};

export const updateMockProposalStatus = (proposal: BusinessProposal, status: ProposalStatus): BusinessProposal => {
  return {
    ...proposal,
    status,
    updated_at: new Date().toISOString()
  };
};

export const createMockContract = (proposal: BusinessProposal): BusinessContract => {
  const now = new Date();
  const startDate = new Date();
  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 12);

  return {
    id: `contract_${uuidv4().substring(0, 8)}`,
    proposal_id: proposal.id,
    customer_id: 'cust_001', // Assuming a default customer ID
    title: `Contrato: ${proposal.title}`,
    description: `Contrato baseado na proposta ${proposal.title}`,
    template_type: proposal.template_type,
    status: 'draft',
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    total_value: proposal.total_value,
    currency_code: proposal.currency_code,
    created_at: now.toISOString(),
    updated_at: now.toISOString(),
  };
};

export const createMockSignatory = (contractId: string, role: 'contractor' | 'contractee'): ContractSignatory => {
  return {
    id: `sig_${uuidv4().substring(0, 8)}`,
    contract_id: contractId,
    name: role === 'contractor' ? 'Representante da Empresa' : 'Representante do Cliente',
    email: role === 'contractor' ? 'representante@suaempresa.com' : 'cliente@cliente.com',
    title: role === 'contractor' ? 'Diretor Comercial' : 'CEO',
    company: role === 'contractor' ? 'Sua Empresa' : 'Empresa Cliente',
    role,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };
}; 